export * from './window.mock';
